import React from 'react';
import Papa from 'papaparse';

// csv파일은 무조건 utf-8로 저장 필요. 참조 : https://becho.tistory.com/307
const setTableDataFile = async (csvFile, valueSet = null) => {
  const response = await fetch(csvFile);
  if (!response.ok) throw new Error(response);
  const csv = await response.text();
  var resultJsonArray = [];
  const papaProcess = await Papa.parse(csv, {
    header: true,
    skipEmptyLines: true,
    step: function (results, parser) {
      if (valueSet) {
        if (results.data[valueSet].indexOf('.') !== -1) {
          const valueArray = results.data[valueSet].split('.');
          results.data[valueSet] = valueArray;
        }
      }
      return resultJsonArray.push(results.data);
    },
  });
  // return resultJsonArray;
  const csvClassObject = new JsonClass(resultJsonArray);

  return csvClassObject;
};

export default setTableDataFile;
// 클래스함수
class JsonClass {
  constructor(value) {
    this.csv = value;
  }

  getList() {
    return this.csv;
  }

  getData(id) {
    if (this.csv.find((el) => el.id === id) === undefined) {
      return undefined;
    } else {
      return this.csv.find((el) => el.id === id);
    }
  }

  getValue(id) {
    const data = this.csv.find((el) => el.id === id);
    if (data === undefined) {
      return undefined;
    } else {
      if (data.value === undefined) {
        return undefined;
      } else {
        return data.value;
      }
    }
  }
  getArrValue(group) {
    let arr = [];
    this.csv.map((v, i) => {
      if (v.groupid === group) {
        arr.push(v);
      } else {
        return undefined;
      }
    });
    return arr;
  }

  getSnsList(sns) {
    let arr = [];
    this.csv.map((v, i) => {
      if (v.category_name === sns) {
        arr.push(v);
      } else {
        return undefined;
      }
    });
    return arr;
  }
  getCityList(data) {
    return this.csv.filter((v) => v.city === data);
  }
  getDepartmentList(subPage, mode) {
    const data = this.csv.find((el) => el.groupid === subPage && el.lang === mode);
    if (data) {
      return data;
    } else {
      return undefined;
    }
  }
  getDepartmentTask(subPage, mode) {
    const data = this.csv.find((el) => el.groupid === subPage && el.lang === mode);
    if (data) {
      return Object.values(data).slice(4);
    } else {
      return undefined;
    }
  }
}
